import {
    normalizeWalletTransactions,
    normalizeExamSessions,
    normalizeBankQuestions,
    mergeActivities,
} from '@/helpers/student-activity';

export default {
    state: {
        appData: null,
        snackMsg: {show: false, text: '', msgBar: true},
        loading: false,
        linearLoading: false,

        announcementDismissed: false,

        homeData: {
            featured_courses: null,
            latest_courses: null,
            packages: null,
        },
        welcomeData: {
            featured_courses: null,
        },
    },
    mutations: {
        SET_APP_DATA(state, payload){
            state.appData = payload.data;
        },
        SET_HOME_DATA(state, payload){
            state.homeData = payload.data;
        },
        SET_WELCOME_DATA(state, payload){
            state.welcomeData = payload.data;
        },
        SET_SNACK_MSG(state, msg){
            state.snackMsg = msg;
        },
        SET_LOADING(state, loading){
            state.loading = loading;
        },
        SET_LINEAR_LOADING(state, loading){
            state.linearLoading = loading;
        },
        SET_ANNOUNCEMENT_DISMISSED(state, dismissed){
            state.announcementDismissed = dismissed;
        },

    },
    actions: {
        loadAppData({commit}){
            let url = '/app';
            return window.axios.get(url).then(response=>{
                commit('SET_APP_DATA', {data: response.data});
            });
        },
        loadHomeData({commit}){
            let url = '/home';
            return window.axios.get(url).then(response=>{
                commit('SET_HOME_DATA', {data: response.data});
                if (response.data && response.data.my_packages){
                    commit('SET_MY_PACKAGES', {data: response.data.my_packages});
                }
            });
        },
        loadWelcomeData({commit}){
            let url = '/welcome';
            return window.axios.get(url).then(response=>{
                commit('SET_WELCOME_DATA', {data: response.data});
            });
        },
        fetchStudentActivities({ rootState }) {
            const appData = rootState.globalModule.appData || {};
            const requests = [
                window.axios.get('/exams/results'),
                window.axios.get('/exams/homeworks/results'),
                window.axios.get('/bank-questions/my-questions'),
            ];

            if (appData.enable_wallet_system) {
                requests.unshift(window.axios.get('/wallet'));
            }

            return Promise.allSettled(requests).then((results) => {
                const activities = [];
                let index = 0;

                if (appData.enable_wallet_system) {
                    const walletResult = results[index++];
                    if (walletResult.status === 'fulfilled') {
                        const transactions = walletResult.value.data.transactions
                            ? walletResult.value.data.transactions.data
                            : [];
                        activities.push(...normalizeWalletTransactions(transactions));
                    }
                }

                const examsResult = results[index++];
                if (examsResult.status === 'fulfilled') {
                    const sessions = examsResult.value.data.data || [];
                    activities.push(...normalizeExamSessions(sessions, 'exam'));
                }

                const homeworkResult = results[index++];
                if (homeworkResult.status === 'fulfilled') {
                    const sessions = homeworkResult.value.data.data || [];
                    activities.push(...normalizeExamSessions(sessions, 'homework'));
                }

                const questionsResult = results[index++];
                if (questionsResult.status === 'fulfilled') {
                    const questions = questionsResult.value.data.data || [];
                    activities.push(...normalizeBankQuestions(questions));
                }

                return mergeActivities(activities, { limit: 12 });
            });
        },
        setLoading({commit}, payload){
            commit('SET_LOADING', payload.loading);
        },
        addSnackMsg({commit}, msg){
            commit('SET_SNACK_MSG', msg);
        },
    }
}